import clsx from 'clsx'
import CodeViewer from 'components/CodeViewer/CodeViewer'
import { formatJSON } from 'helpers/format'
import { PackageOpenIcon } from 'lucide-react'
import { IdEventV4 } from 'models/event'

import { IdentificationUrlKeys } from '../../../types'
import { SmartSignalDefinition } from './SmartSignalRepresentation'

export const jailbreakDefinition: SmartSignalDefinition<{ jailbroken?: IdEventV4['jailbroken'] }> = {
  key: 'jailbreak',
  label: 'Jailbreak',
  extract: (e) => ({ jailbroken: e.jailbroken }),
  icon(e) {
    const p = this.extract(e)?.jailbroken
    return (
      <PackageOpenIcon
        className={clsx('size-4', {
          'text-red-800': p,
        })}
      />
    )
  },
  details(e) {
    return (
      <CodeViewer
        value={formatJSON(this.extract(e))}
        withSearch={false}
        className={this.isDetected(e) ? 'bg-red-100 border-red-300' : 'bg-gray-100'}
      />
    )
  },
  isDetected(e) {
    const p = this.extract(e)?.jailbroken
    return p === true
  },
  isWeb: () => false,
  isMobile: () => true,
  searchFor: '"jailbroken":',
  documentationHash: '#jailbroken-device-detection',
  urlParamKey: IdentificationUrlKeys.JailbrokenDevice,
}
